const translations = {
  hello: 'Hello',
  welcome: 'Welcome',
};

export default translations;